import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-helena-privacy',
  template: `
  <h2>Legal Statements</h2>
  <h3>Privacy</h3>
  <h3>Commercial Confidentiality</h3>`
})
export class HelenaPrivacyComponent implements OnInit {
  constructor() { }
  ngOnInit() {
  }

}
